import { DefaultSidebar } from "@excalidraw/excalidraw";

/** Keep only search + library; no Excalidraw+ promo tabs. */
export const AppSidebar = () => {
  return <DefaultSidebar />;
};
